/**
 * Checks if the current page is in bubble embed mode.
 * Detects bubble mode by checking for both 'embed=true' and 'bubble=true' URL parameters.
 */
export function isBubbleMode(): boolean {
  const urlParams = new URLSearchParams(window.location.search)
  return urlParams.get('embed') === 'true' && urlParams.get('bubble') === 'true'
}
